import { render, staticRenderFns } from "./recent.vue?vue&type=template&id=250a91a5&"
import script from "./recent.js?vue&type=script&lang=js&"
export * from "./recent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports